import { render, staticRenderFns } from "./GlobalSearchSkeletonCard.vue?vue&type=template&id=40e9e423&scoped=true"
import script from "./GlobalSearchSkeletonCard.vue?vue&type=script&lang=js"
export * from "./GlobalSearchSkeletonCard.vue?vue&type=script&lang=js"
import style0 from "./GlobalSearchSkeletonCard.vue?vue&type=style&index=0&id=40e9e423&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e9e423",
  null
  
)

export default component.exports